import React from 'react';
import { string, oneOfType, array, object } from 'prop-types';
import { get, join } from 'lodash';
import { cleanOrderId } from '../../../utils/misc';
import { Card, FlexContainer, Text, Box, OrderShippingEstimate, Row, Column, Divider, Truncate, Button } from '../../common';
import Link from '../../routes/Link';
import FormPOS from '../FormPOS';

const InvoicingCard = ({ id, session, ...data }) => {
    const barcodeData = {
        id,
        code: get(data, 'assignInfo.eanOrder', '0')
    };
    return (
        <Box style={{ padding: '10px' }} width={['90%', '50%', '20%']}>
            <OrderShippingEstimate id={id} {...data}>
                {({ isDelayed, diffInMinutes, shippingColor, deliveryDate, deliveryTime, deliveryTimeHour }) => {
                    const isExpress = get(data, 'logisticsInfo.selectedSla', null) === 'Despacho Express';
                    return (
                        <Card
                            leftHeader={() =>
                                <FlexContainer direction='column'>
                                    <Row>
                                        <Link href={`/orders/${id}`}>
                                            <Text
                                                text={cleanOrderId(id)}
                                                size={14}
                                                strong
                                                color='#4cb358'
                                            />
                                        </Link>
                                    </Row>
                                    <Row>
                                        <Text text={`Entrega ${deliveryDate}`} />
                                    </Row>
                                    <Row mT={10}>
                                        <Column>
                                            <Text text={isExpress ? deliveryTimeHour : deliveryTime} strong size={11} />
                                            <Text size={11} text='Hora entrega' />
                                        </Column>
                                    </Row>
                                </FlexContainer>
                            }
                            bodyChildren={() =>
                                <>
                                    <FormPOS data={data} />
                                    <Divider />
                                    <Row justify='center'>
                                        <Text text={get(barcodeData, 'code')} strong />
                                    </Row>
                                    <Divider />
                                    <Row>
                                        <Column align='flex-start' justify='center'>
                                            <Text text='Shopper' />
                                        </Column>
                                        <Column align='flex-end' justify='center' flex={1.5}>
                                            <Text
                                                align='right'
                                                text={
                                                    <Truncate width={150}>
                                                        {join([get(data, 'assignInfo.picker.firstName'), get(data, 'assignInfo.picker.lastName')], ' ')}
                                                    </Truncate>
                                                }
                                            />
                                        </Column>
                                    </Row>
                                </>
                            }
                            footerChildren={() =>
                                <>
                                    <Divider />
                                    <Row justify='center'>
                                        <Button
                                            text='Imprimir'
                                            secondary
                                            fitContent
                                            onClick={() => window.open(`/invoicing-orders/${JSON.stringify([barcodeData])}`, '_blank')}
                                        />
                                    </Row>
                                </>
                            }
                        />
                    );
                }}
            </OrderShippingEstimate>
        </Box>
    );
};

InvoicingCard.propTypes = {
    id: string,
    data: oneOfType([array, object]),
    session: oneOfType([array, object])
};

InvoicingCard.defaultProps = {
    id: '0-0',
    data: {},
    session: {}
};

export default InvoicingCard;
